import Button from './button';
import Divider from './divider';
import Form from './form';
import Overlay from './overlay';
import Styles from './styles';
import TranslatedMessage from './translated-message';
import UserImage from './user-image';
import OrganizationImage from './organization-image';
import SocialButtons from './social-buttons';
import PageButtons from './page-buttons';

export default {
  Button,
  Divider,
  Form,
  Overlay,
  Styles,
  TranslatedMessage,
  UserImage,
  OrganizationImage,
  SocialButtons,
  PageButtons
};



// WEBPACK FOOTER //
// ./src/components/index.js